var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shan3_ball",style:(_vm.getStyles)},_vm._l((50),function(idx,index){return _c('img',{key:'shan3_ani'+idx,class:'shan3_ani'+idx,style:(_vm.getLuoItemStyle(index)),attrs:{"src":_vm.getLuoItem(index)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }